import type { ReactNode } from "react";
import {
  Layout as RALayout,
  CheckForApplicationUpdate,
  Menu,
  MenuItemLink,
  AppBar,
  UserMenu,
} from "react-admin";
import { Home, BookOnline, People, Dashboard, Settings, CardGiftcard, LocalOffer } from "@mui/icons-material";
import { Box } from "@mui/material";

const CustomAppBar = () => (
  <AppBar userMenu={<UserMenu />}>
    <Box display="flex" alignItems="center" gap={2}>
      <img src="/logo-white.png" alt="TripNester" style={{ height: "32px" }} />
      <Box>
        <Box component="span" sx={{ fontWeight: 600, fontSize: "1.1rem" }}>
          Admin Dashboard
        </Box>
      </Box>
    </Box>
  </AppBar>
);

export const Layout = ({ children }: { children: ReactNode }) => (
  <RALayout
    appBar={CustomAppBar}
    menu={() => (
      <Menu>
        <MenuItemLink to="/" primaryText="Dashboard" leftIcon={<Dashboard />} />
        <MenuItemLink
          to="/properties"
          primaryText="Properties"
          leftIcon={<Home />}
        />
        <MenuItemLink
          to="/bookings"
          primaryText="Bookings"
          leftIcon={<BookOnline />}
        />
        <MenuItemLink to="/users" primaryText="Users" leftIcon={<People />} />
        <MenuItemLink
          to="/providers"
          primaryText="Providers"
          leftIcon={<Settings />}
        />
        <MenuItemLink
          to="/referrals"
          primaryText="Referrals"
          leftIcon={<CardGiftcard />}
        />
        <MenuItemLink
          to="/promotions"
          primaryText="Promotions"
          leftIcon={<LocalOffer />}
        />
      </Menu>
    )}
  >
    {children}
    <CheckForApplicationUpdate />
  </RALayout>
);
